<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="$t('reports.title')"></page-header-title>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-select
                  :items="$dd_reports()"
                  item-text="text"
                  item-value="key"
                  :label="$t('reports.select_report')"
                  v-model="selectedReport"
                >
                </v-select>
              </v-flex>
              <v-flex xs12>
                <component :is="selectedReport"></component>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ReportList",

  components: {
    "sms-usage-report": () => import("../components/SMSUsageReport"),
    "organisation-tenant-report": () => import("../components/OrganisationTenantReport"),
    "tenant-usage-report": () => import("../components/TenantUsageReport"),
    "tenant-number-of-completed-course": () => import("../components/TenantNumberOfCompletedCourse.vue"),
    "tenant-number-of-expertise": () => import("../components/TenantNumberOfExpertise.vue")
  },

  data() {
    return {
      selectedReport: null
    }
  }
}
</script>
